var _rect, _path, _path2, _path3, _path4, _path5, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPeopleUpdates = function SvgPeopleUpdates(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 5.3,
    fill: "#FEF6E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.19971 18.4V7.6C8.19971 7.2688 8.46851 7 8.79971 7H15.9997C16.9939 7 17.7997 7.8058 17.7997 8.8V17.2C17.7997 18.1942 16.9939 19 15.9997 19H8.79971C8.46851 19 8.19971 18.7312 8.19971 18.4Z",
    fill: "#5A6367"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9997 12.9994C13.9938 12.9994 14.7997 12.1935 14.7997 11.1994C14.7997 10.2053 13.9938 9.39941 12.9997 9.39941C12.0056 9.39941 11.1997 10.2053 11.1997 11.1994C11.1997 12.1935 12.0056 12.9994 12.9997 12.9994Z",
    fill: "#C5C5CA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8 14.2002H11.2C10.537 14.2002 10 14.7372 10 15.4002C10 16.0632 10.537 16.6002 11.2 16.6002H14.8C15.463 16.6002 16 16.0632 16 15.4002C16 14.7372 15.463 14.2002 14.8 14.2002Z",
    fill: "#C5C5CA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2 14.7998C8.1076 14.7998 8.0158 14.7998 7.9 14.7998C7.4032 14.7998 7 15.203 7 15.6998C7 16.1966 7.4032 16.5998 7.9 16.5998C8.0158 16.5998 8.1076 16.5998 8.2 16.5998V14.7998Z",
    fill: "#C5C5CA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2 9.39941C8.1076 9.39941 8.0158 9.39941 7.9 9.39941C7.4032 9.39941 7 9.80261 7 10.2994C7 10.7962 7.4032 11.1994 7.9 11.1994C8.0158 11.1994 8.1076 11.1994 8.2 11.1994V9.39941Z",
    fill: "#C5C5CA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 5.3,
    stroke: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPeopleUpdates);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "people-updates.d256c9e08abb73154fa6ebe06d4d5416.svg";